/**
 * Qué se muestra del lado comercial del producto.
 *
 * Durante la etapa de tesis el sistema se presenta como herramienta, no como
 * servicio con precios: las ferreterías que lo prueban lo hacen sin costo y el
 * objetivo es la encuesta, no la venta. Hablar de planes, vencimientos o de
 * «activar tu plan» desvía esa conversación y, en una defensa, invita a
 * preguntas sobre un modelo de negocio que todavía no es el tema.
 *
 * Está acá y no repetido en cada pantalla para que volver a mostrarlo —después
 * de la tesis, cuando el SaaS se comercialice— sea cambiar este valor y nada
 * más. Afecta la página pública y el aviso de suscripción del panel.
 */
export const MOSTRAR_PLANES = false;
